var map = {
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"default~authentication-authentication-module~insti-insti-module~natureza51-natureza51-module",
		"authentication-authentication-module"
	],
	"./dashboards/dashboards.module": [
		"./src/app/dashboards/dashboards.module.ts",
		"default~dashboards-dashboards-module~natureza51-natureza51-module",
		"dashboards-dashboards-module"
	],
	"./insti/insti.module": [
		"./src/app/insti/insti.module.ts",
		"default~authentication-authentication-module~insti-insti-module~natureza51-natureza51-module",
		"insti-insti-module"
	],
	"./natureza51/natureza51.module": [
		"./src/app/natureza51/natureza51.module.ts",
		"default~authentication-authentication-module~insti-insti-module~natureza51-natureza51-module",
		"default~dashboards-dashboards-module~natureza51-natureza51-module",
		"natureza51-natureza51-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;